export default {
  methods: {
    createOptionMixinFn(newOption) {
      // INFO: Orginal option overrided,
      // so we will get consistent object
      // https://vue-select.org/api/props.html#createoption
      newOption = { itemData: newOption }
      this.$emit('option:created', newOption)
      return newOption
    }
  }
}
